"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/routing";
import { useAccount } from "@/components/account/AccountProvider";

/**
 * "Create poster" — the funnel entry, and only for people who are not signed in.
 *
 * A signed-in customer's header says one thing: where their account is. They already know how to
 * make a poster; the account page carries a create button of its own, and on a phone the two links
 * were fighting for the same handful of pixels.
 *
 * Deliberately rendered WHILE /me is still in flight, unlike the account entry: this is the main
 * call to action for a first-time visitor, and it must not blink into existence a moment after the
 * header paints. It disappears again only if an account actually turns up.
 */
export function CreatePosterLink() {
  const t = useTranslations("common");
  const { account, loading } = useAccount();

  if (!loading && account) return null;

  return (
    <Link className="whitespace-nowrap" data-nav-create href="/upload">
      {t("nav.custom")}
    </Link>
  );
}
